const reloadTimestampKey = 'openflis-stale-deployment-reload';
const reloadCooldownMilliseconds = 60_000;

const staleDeploymentMessages = [
    'Failed to fetch dynamically imported module',
    'Importing a module script failed',
    'ChunkLoadError',
    'Loading chunk'
];

export function reloadAfterStaleDeployment(
    error: unknown,
    reload: () => void = () => window.location.reload(),
    storage: Storage = window.sessionStorage,
    now: number = Date.now()
): boolean {
    const message = error instanceof Error ? error.message : String(error ?? '');
    if (!staleDeploymentMessages.some(candidate => message.includes(candidate))) {
        return false;
    }

    const previousReload = Number(storage.getItem(reloadTimestampKey));
    if (Number.isFinite(previousReload)
        && previousReload > 0
        && now - previousReload < reloadCooldownMilliseconds) {
        return false;
    }

    storage.setItem(reloadTimestampKey, String(now));
    reload();
    return true;
}
